import { render, staticRenderFns } from "./EDAPremiumPreSaleSection.vue?vue&type=template&id=dcc98e4c&"
import script from "./EDAPremiumPreSaleSection.vue?vue&type=script&lang=js&"
export * from "./EDAPremiumPreSaleSection.vue?vue&type=script&lang=js&"
import style0 from "./EDAPremiumPreSaleSection.vue?vue&type=style&index=0&id=dcc98e4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports